import { render } from "./Outdated.vue?vue&type=template&id=6c37e2bb&lang=pug"
import script from "./Outdated.vue?vue&type=script&lang=ts"
export * from "./Outdated.vue?vue&type=script&lang=ts"

import "./Outdated.vue?vue&type=style&index=0&id=6c37e2bb&lang=scss"
script.render = render

export default script